import React, { useState, useEffect, useLayoutEffect, useMemo } from "react";
import styled from "styled-components";
import AdminAPI from "../../apis/AdminAPI";
import clean from "clean-deep";
import { ReactComponent as Eye } from "../../assets/svg/eye.svg";
import { ReactComponent as Reload } from "../../assets/svg/reload.svg";
import { ReactComponent as Lock } from "../../assets/svg/lock.svg";
import UserTree from "./UserTree";
import Modal from "../Modal";
import Button from "../Button";
import ShortMessage from "../ShortMessage";
import SimpleBar from "simplebar-react";
import "simplebar/dist/simplebar.min.css";
import { Parser } from "json2csv";
import Input from "../Input";
import produce from "immer";
import ModalTree from "./ModalTree";
import { disableSecurity, unassingDeviceId } from "../../apis/User";
import ModalInfo from "../molecules/ModalInfo";
import Text from "../atoms/Text";
import ButtonAtom from "../atoms/Button";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { Chip } from "@mui/material";


const getDatePlus30 = () => {
  let date = new Date(); // Now
  date.setDate(date.getDate() + 30); // Set now + 30 days as the new date
  return date;
}


const getDatePlus = () => {
  let date = new Date(); // Now
  date.setDate(date.getDate()); // Set now + 30 days as the new date
  return date;
}

const Users = () => {
  const [modalSuccess, setModalSuccess] = useState(false);
  const [modalCorrect, setModalCorrect] = useState(false);
  const [showModalEditSecurity, setShowModalEditSecurity] = useState(undefined);
  const [finishDate, setFinishDate] = useState(getDatePlus30());


  const [searchText, setSearchText] = useState(undefined);

  const [users, setUsers] = useState(undefined);
  const [quantity, setQuantity] = useState(10);
  const [showTree, setShowTree] = useState(undefined);
  const [showShortMessage, setShowShortMessage] = useState(undefined);

  useEffect(() => {
    const unsubscribe = AdminAPI.subscribeToUsers(
      quantity,
      (user) => {
        setUsers((state) => ({ ...state, [user.id]: { ...user, searchText } }));
      },
      (userId) => setUsers((state) => ({ ...state, [userId]: undefined })),
      searchText
    );
    return () => unsubscribe();
  }, [quantity, searchText]);

  const usersArray = useMemo(() => {
    if (!users) return [];

    return produce(users, (draft) => {
      return toArray(clean(draft))
        .sort((a, b) => b.createdAt - a.createdAt)
        .filter(
          (user) =>
            (searchText !== undefined &&
              searchText !== "" &&
              user.searchText === searchText) ||
            searchText === undefined ||
            searchText === ""
        );
    });
  }, [users, searchText]);

  // console.log(users);

  const onLoad = () => setQuantity((state) => state + 10);

  return (
    <>
      <Container className="p-4">
        {showShortMessage && (
          <ShortMessage
            wrong={showShortMessage?.state === "WRONG"}
            success={showShortMessage?.state === "SUCCESS"}
            message={showShortMessage?.message}
            onAccept={() =>
              showShortMessage?.onAccept && showShortMessage.onAccept()
            }
          />
        )}

        {showTree && (
          <ModalTree
            userId={showTree?.userId}
            userLastname={showTree?.userLastname}
            userName={showTree?.userName}
            onClose={() => setShowTree(undefined)}
          />
        )}
        <Buttons>
          <ButtonExport
            onClick={() => {
              const formatted = clean(
                usersArray.map((u) => ({
                  ...u,
                  createdAt: new Date(u.createdAt).toLocaleString(),
                  seed: undefined,
                }))
              );
              const json2csvParser = new Parser();
              const csvContent =
                "data:text/csv;charset=utf-8," +
                json2csvParser.parse(formatted);

              const path = `${Date.now()}_usuarios.csv`;

              let encodedUri = encodeURI(csvContent);
              let link = document.createElement("a");
              link.setAttribute("href", encodedUri);
              link.setAttribute("download", path);
              document.body.appendChild(link);

              link.click();
            }}
          >
            Exportar a Excel
          </ButtonExport>
        </Buttons>
        <InputStyled
          placeholder="Texto de busqueda"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
        />
        <UsersWrapper>
          {usersArray.map((user) => (
            <UserWrapper key={`${user.id}`} className="p-4 w-[150px]">
              {user.name !== undefined && user.lastname !== undefined ? (
                <>
                  <Fullname>{`${user.name} ${user.lastname}`}</Fullname>
                  <Email>{user.email}</Email>
                </>
              ) : (
                <>
                  <Fullname>{user.name}</Fullname>
                  <Email>{user.email}</Email>
                </>
              )}

              <Phone>{user.phone}</Phone>
              <UserId>{user.id}</UserId>
              {user.seed && <Chip label="Premium" color="info" />}
              {user.orders !== undefined && <Chip label="Con tarjeta" color="success" />}
              {user.createdAt && (
                <>
                  <Time>{`${new Date(user.createdAt).toLocaleDateString(
                    "es-ES"
                  )}`}</Time>
                  <Time>{`${new Date(user.createdAt).toLocaleTimeString(
                    "es-ES"
                  )}`}</Time>
                </>
              )}
              {user.isAutocreated === true && <Tag>Autogenerado</Tag>}
              <Options>
                <OptionIcon
                  as={Eye}
                  onClick={() =>
                    setShowTree({
                      userId: user.id,
                      userName: user.name,
                      userLastname: user.lastname,
                    })
                  }
                />
                {/* {(user.seed || user.isAutocreated) && (
                  <OptionIcon
                    as={Reload}
                    onClick={() => {
                      unassingDeviceId(user.id).then(() => {
                        setModalSuccess(true);
                      });
                    }}
                  />
                )}
                <OptionIcon as={Lock} onClick={() => {
                  setShowModalEditSecurity({
                    name: user.name,
                    lastname: user.lastname,
                    id: user.id
                  });
                  setFinishDate(getDatePlus30());

                }} /> */}
              </Options>
            </UserWrapper>
          ))}
          {/* {usersArray.length <= quantity && ( */}
          <Option onClick={onLoad}>
            <Plus>+10</Plus>
          </Option>
          {/* )} */}
        </UsersWrapper>
      </Container>
      <ModalInfo
        isOpen={showModalEditSecurity !== undefined}
        onRequestClose={() => setShowModalEditSecurity(undefined)}
        message={
          <>
            {showModalEditSecurity !== undefined && 
            <>
              <Text type="p">
              Desactivar la seguridad al usuario <b>{`${showModalEditSecurity.name} ${showModalEditSecurity.lastname}`}</b>
            </Text>
            <br/>
            <br/>
            <Text>¿Hasta cuando piensas desactivar la seguridad? (por defecto es 30 días)</Text>
            <br/>
            <DatePicker dateFormat="dd/MM/yyyy" minDate={getDatePlus()} preventOpenOnFocus={true} selected={finishDate} onChange={(date) => setFinishDate(date)} />
            </>}
          </>
        }
        actions={
          <>
          <ButtonAtom
            type="secondary"
            label="Cancelar"
            onClick={() => setShowModalEditSecurity(undefined)}
          />
          <ButtonAtom
            type="primary"
            label="Aceptar"
            onClick={() => {
              finishDate.setHours(0,0,0,0);
              disableSecurity(showModalEditSecurity.id,finishDate).then(() => {
                setModalCorrect(true);
              }).catch( ()=> {
                alert("Inténtalo de nuevo, ocurrió un error.")
              });
            }}
          />
          </>
        }
      />
       <ModalInfo
        isOpen={modalCorrect}
        onRequestClose={() => {
          setModalCorrect(false);
          setShowModalEditSecurity(undefined);
        }}
        message={
          <>
            {showModalEditSecurity !== undefined && <>
              <Text type="p">
              El usuario <b>{`${showModalEditSecurity.name} ${showModalEditSecurity.lastname}`}</b> podrá acceder sin restricciones de dispositivo hasta el día <b>{moment(finishDate).format("DD/MM/YYYY")}</b>. Puedes cambiarlo cuando quieras!
            </Text>
            </>}
          </>
        }
        actions={
          <ButtonAtom
            type="primary"
            label="Aceptar"
            onClick={() => {
              setModalCorrect(false);
              setShowModalEditSecurity(undefined);
            }}
          />
        }
      />
      <ModalInfo
        isOpen={modalSuccess}
        onRequestClose={() => setModalSuccess(false)}
        message={
          <>
            <Text type="p">
              El usuario ahora podrá asignar un nuevo dispositivo.
            </Text>
          </>
        }
        actions={
          <ButtonAtom
            type="primary"
            label="Aceptar"
            onClick={() => setModalSuccess(false)}
          />
        }
      />
    </>
  );
};

const toArray = (obj) =>
  Object.keys(obj || {}).map((key) => ({ id: key, ...obj[key] }));

const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const UsersWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
`;

const UserWrapper = styled.div`
  margin: 5px;
  border-radius: 10px;
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px;
  width: 110px;
  min-height: 110px;

  & > *:not(:last-child) {
    margin-bottom: 5px;
  }
`;

const Fullname = styled.div`
  font-weight: 600;
  word-break: break-word;
  text-align: center;
`;

const Email = styled.div`
  font-size: 0.7em;
  word-break: break-word;
  text-align: center;
`;

const Phone = styled.div`
  font-size: 0.7em;
  text-align: center;
`;

const Seed = styled.div`
  font-size: 0.6em;
  text-align: center;
  background-color: #2196f3;
  padding: 5px;
  border-radius: 10px;
  word-break: break-all;
  color: white;
`;

const UserId = styled.div`
  font-size: 0.6em;
  text-align: center;
  padding: 5px;
  border-radius: 10px;
  word-break: break-all;
  font-weight: 600;
`;

const Options = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const OptionIcon = styled.div`
  fill: rgba(0, 0, 0, 0.5);
  width: 20px;
  height: 20px;
  min-width: 20px;
  min-height: 20px;
  padding: 5px;
  margin: 5px;
  cursor: pointer;
`;

const ModalStyled = styled(Modal)`
  max-width: 450px;
  width: 100%;
  display: flex;
  flex-direction: column;
  max-height: 95%;
`;

const ButtonStyled = styled(Button)`
  margin-top: 10px;
  margin-bottom: 10px;
`;

const Content = styled.div`
  width: 100%;
`;

const Option = styled.div`
  margin: 5px;
  border-radius: 10px;
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px;
  width: 110px;
  height: 110px;
  cursor: pointer;
  border: 2px dashed #2196f3;
`;

const Plus = styled.div`
  color: #2196f3;
  font-size: 1.3em;
  font-weight: 600;
`;

const ButtonExport = styled.div`
  border-radius: 10px;
  padding: 10px 15px;
  border: 1px solid #2196f3;
  color: #2196f3;
  font-size: 0.8em;
  font-weight: bold;
  cursor: pointer;
  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
`;

const Buttons = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  margin: 10px 0px 20px 0px;
  box-sizing: border-box;
`;

const InputStyled = styled(Input)`
  margin-bottom: 10px;
  margin-left: 5vw;
  max-width: 90vw;
`;

const Time = styled.div`
  font-size: 0.7em;
  text-align: center;
`;

const Tag = styled.div`
  padding: 2px 5px;
  border-radius: 5px;
  border: 1px solid #2196f3;
  font-size: 0.7em;
  color: #2196f3;
`;


export default Users;
